var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { defineComponent } from "@vue/composition-api";
export function component(options) {
    return defineComponent(options);
}
export function emit(ctx, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    ctx.emit.apply(ctx, __spreadArrays([name], args));
}
export function emitOn(ctx, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    ctx.emit.apply(ctx, __spreadArrays([name.replace(/^on[A-Z]/, function (v) { return v[2].toLowerCase(); })], args));
}
export function updateEmitter() {
    return function (ctx, name, value) {
        ctx.emit("update:" + name, value);
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmNhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3ZjYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0EsT0FBTyxFQUNMLGVBQWUsRUFJaEIsTUFBTSxzQkFBc0IsQ0FBQztBQXdGOUIsTUFBTSxVQUFVLFNBQVMsQ0FBQyxPQUFZO0lBQ3BDLE9BQU8sZUFBZSxDQUFDLE9BQU8sQ0FBUSxDQUFDO0FBQ3pDLENBQUM7QUFFRCxNQUFNLFVBQVUsSUFBSSxDQUNsQixHQUFtQyxFQUNuQyxJQUFVO0lBQ1YsY0FBK0M7U0FBL0MsVUFBK0MsRUFBL0MscUJBQStDLEVBQS9DLElBQStDO1FBQS9DLDZCQUErQzs7SUFFL0MsR0FBRyxDQUFDLElBQUksT0FBUixHQUFHLGtCQUFNLElBQUksR0FBSyxJQUFJLEdBQUU7QUFDMUIsQ0FBQztBQUVELE1BQU0sVUFBVSxNQUFNLENBQ3BCLEdBQW1DLEVBQ25DLElBQVU7SUFDVixjQUErQztTQUEvQyxVQUErQyxFQUEvQyxxQkFBK0MsRUFBL0MsSUFBK0M7UUFBL0MsNkJBQStDOztJQUUvQyxHQUFHLENBQUMsSUFBSSxPQUFSLEdBQUcsa0JBQ0QsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLEVBQUUsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsV0FBVyxFQUFFLEVBQWxCLENBQWtCLENBQUMsR0FDOUMsSUFBSSxHQUNQO0FBQ0osQ0FBQztBQUVELE1BQU0sVUFBVSxhQUFhO0lBQzNCLE9BQU8sVUFBaUMsR0FBaUIsRUFBRSxJQUFPLEVBQUUsS0FBZTtRQUNqRixHQUFHLENBQUMsSUFBSSxDQUFDLFNBQVMsR0FBRyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDcEMsQ0FBQyxDQUFDO0FBQ0osQ0FBQyJ9